﻿import {useMemo} from 'react';
import {useGetRequestAutoAbortPaginated} from "../../request/useGetRequestAutoAbortPaginated";
import {supplierCurrentInventoryReportEndpoints} from "../../../requests/api-endpoints";
import {InventoryReportViewVO} from '../../../types/model/valueObject/InventoryReportViewVO';
import {SupplierInventorySortByType} from "../../../types/supplier/SupplierInventorySortByType";
import {SortDirType} from "../../../types/common/SortDirType";

interface UseSupplierCurrentInventories {
  page?: number | string;
  size?: number | string;
  locationId?: string;
  buyerId?: string;
  equipmentNumber?: string;
  bookingNumber?: string;
  sortBy?: SupplierInventorySortByType;
  sortDir?: SortDirType;
}

const useSupplierCurrentInventories = ({ page, size, locationId, buyerId, equipmentNumber, bookingNumber, sortBy, sortDir }: UseSupplierCurrentInventories) => {
  const queryParams = useMemo(() => ({
    page,
    size,
    locationId,
    buyerId,
    equipmentNumber,
    bookingNumber,
    sortBy,
    sortDir,
  }), [page, size, locationId, buyerId, equipmentNumber, bookingNumber, sortBy, sortDir]);

  const {
    responseContent: currentInventories,
    pageInfo,
    isLoading,
    error,
    doRequest
  } = useGetRequestAutoAbortPaginated<InventoryReportViewVO[]>({ requestUrl: supplierCurrentInventoryReportEndpoints.search, queryParams });

  return {
    currentInventories,
    pageInfo,
    isLoading,
    error,
    doRequest
  }
}

export { useSupplierCurrentInventories };
